import {gql} from "@apollo/client";
import { client } from "graphql/client";

// 创建客服智控角色
export const CREATE_ACCOUNT_KAQC = gql`
    mutation CreateAccountKAQC($input: AccountKAQCInput!) {
        createAccountKAQC(input: $input)
    }
`;

// 更新客服智控角色
export const UPDATE_ACCOUNT_KAQC = gql`
    mutation UpdateAccountKAQC($input: AccountKAQCInput!) {
        updateAccountKAQC(input: $input)
    }
`;

export interface AccountKAQCInput {
    id?: string;
    email?: string;
    countryCode: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
    role: string;
}

export const createAccountKAQC = async (input: AccountKAQCInput): Promise<boolean> => {
        const {data} = await client.mutate({
            mutation: CREATE_ACCOUNT_KAQC,
            variables: {input}
        });
        return data.createAccountKAQC;
};

export const updateAccountKAQC = async (input: AccountKAQCInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: UPDATE_ACCOUNT_KAQC,
        variables: {input}
    });
    return data.updateAccountKAQC;
};
